module.exports = __webpack_public_path__ + "static/media/breadcrumb-head-unselected.49fdc371.svg";